//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'CO_Fick',
  data() {
    return {
      defaultJson: {
        'VO₂': 'VO₂',
        'Hemoglobin': '血红蛋白',
        'Cardiac Index': '心脏指数',
        'SaO₂': 'SaO₂',
        'Cardiac Output': '心输出量',
        'SṽO₂': 'SṽO₂',
        'BSA': 'BSA'
      },
      form: {
        fHb: '',
        fSaO2: '',
        fSvO2: '',
        fVO2: '',
        bsa: ''
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        { value: '0', name: '从不' },
        { value: '10', name: '一周内' },
        { value: '5', name: '曾有' }
      ],
      dataList2: [
        { value: '0', name: '从不' },
        { value: '10', name: '6个月内' },
        { value: '5', name: '超过6个月' }
      ],
      logit: '...'
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      console.log(self.form)
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }

      if (!flag) {
        self.hasScore = false
        self.logit = '...'
        return '...'
      } else {
        console.log(form)
        let result = form.fVO2 / (13.4 * form.fHb * (form.fSaO2 - form.fSvO2))
        // if (result < 15) {
        //   self.logit = self.defaultJson['Class I']
        // } else if (result < 30) {
        //   self.logit = self.defaultJson['Class II']
        // } else {
        //   self.logit = self.defaultJson['Class III']
        // }
        var Cardiac = result / form.bsa
        self.hasScore = true
        return {
          score: String((result * 100).toFixed(1)),
          Cardiac: String((Cardiac * 100).toFixed(1))
        }
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/CO_Fick.vue